import { v4 as uuidv4 } from 'uuid';

const SHOPPER_FLOW_KEY = 'strim-shopper-flow';

export const SHOPPER_FLOW_TTL_MS = 60 * 60 * 1000;

/** How the flow started: a click on an asset page, or a new-productIds link (campaign, mail, CMS) */
export type ShopperFlowSource = 'asset' | 'link';

export type ShopperFlow = { id: string; source: ShopperFlowSource };

type StoredShopperFlow = ShopperFlow & { startedAt: number };

export const startShopperFlow = (source: ShopperFlowSource): ShopperFlow => {
  const flow: ShopperFlow = { id: uuidv4(), source };
  try {
    const stored: StoredShopperFlow = { ...flow, startedAt: Date.now() };
    sessionStorage.setItem(SHOPPER_FLOW_KEY, JSON.stringify(stored));
  } catch {}
  return flow;
};

export const getShopperFlow = (): ShopperFlow | null => {
  try {
    const raw = sessionStorage.getItem(SHOPPER_FLOW_KEY);
    if (!raw) return null;
    const stored: Partial<StoredShopperFlow> = JSON.parse(raw);
    const isValid =
      typeof stored.id === 'string' &&
      typeof stored.startedAt === 'number' &&
      (stored.source === 'asset' || stored.source === 'link');
    if (!isValid || Date.now() - stored.startedAt! > SHOPPER_FLOW_TTL_MS) {
      sessionStorage.removeItem(SHOPPER_FLOW_KEY);
      return null;
    }
    return { id: stored.id!, source: stored.source! };
  } catch {
    return null;
  }
};

export const getShopperFlowId = (): string | null => getShopperFlow()?.id ?? null;

export const clearShopperFlow = (): void => {
  try {
    sessionStorage.removeItem(SHOPPER_FLOW_KEY);
  } catch {
    // ignore
  }
};
